export default "__VITE_ASSET__01802119__"